import { CheckoutCardProvider } from '../../models/checkout-card/checkout-card-provider.enum';
import { PaysafeConfig } from '../../models/paysafe/paysafe-config.interface';
import { PaysafeEnvironment } from '../../models/paysafe/paysafe-environment.enum';

export const mockPaysafeConfig: PaysafeConfig = {
  accountId: 1,
  key: 'key',
  environment: PaysafeEnvironment.Test,
  provider: CheckoutCardProvider.Paysafe,
};
